import { initCommonUi } from "../../common";

const BUGSNAG_API_KEY = process.env.BUGSNAG_API_KEY;
const RELEASE_STAGE = process.env.APP_RELEASE_STAGE;
const VERSION = process.env.APP_VERSION;

const run = () => {
  initCommonUi({
    bugsnag: {
      apiKey: BUGSNAG_API_KEY,
      releaseStage: RELEASE_STAGE,
      appVersion: VERSION,
    },
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", run, { once: true });
} else {
  run();
}
